import CryptoJS from "crypto-js";
import pako from "pako";

const SECRET_KEY = "582c34c5e9c8ab0849bd88a52cc45b9ddfb81deb5b8a189e54f2ace4f6755dc9";

/* Base64url helpers */
function base64UrlEncode(base64: string): string {
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function base64UrlDecode(urlSafe: string): string {
  let base64 = urlSafe.replace(/-/g, "+").replace(/_/g, "/");
  while (base64.length % 4 !== 0) {
    base64 += "=";
  }
  return base64;
}

/* Encryption */
export const encryptQuery = (data: Record<string, any>): string => {
  const json = JSON.stringify(data);
  const compressedBytes = pako.deflate(json);
  const wordArray = CryptoJS.lib.WordArray.create(compressedBytes as any);
  const encrypted = CryptoJS.AES.encrypt(wordArray, SECRET_KEY).toString();
  return base64UrlEncode(encrypted);
};

/* Decryption */
export const decryptQuery = (cipherText: string): Record<string, any> | null => {
  try {
    const base64 = base64UrlDecode(cipherText);
    const decrypted = CryptoJS.AES.decrypt(base64, SECRET_KEY);
    const decryptedBytes = decrypted.sigBytes;
    const uint8Array = new Uint8Array(decryptedBytes);
    for (let i = 0; i < decryptedBytes; i++) {
      uint8Array[i] = decrypted.words[i >>> 2] >>> (24 - (i % 4) * 8) & 0xff;
    }
    const json = new TextDecoder().decode(pako.inflate(uint8Array));
    return JSON.parse(json);
  } catch (e) {
    console.error("Decryption failed:", e);
    return null;
  }
};
